import { render, staticRenderFns } from "./edit-installation-responsible-dialog.vue?vue&type=template&id=8aaf0dae&scoped=true"
import script from "./edit-installation-responsible-dialog.vue?vue&type=script&lang=js"
export * from "./edit-installation-responsible-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-installation-responsible-dialog.vue?vue&type=style&index=0&id=8aaf0dae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaf0dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aaf0dae')) {
      api.createRecord('8aaf0dae', component.options)
    } else {
      api.reload('8aaf0dae', component.options)
    }
    module.hot.accept("./edit-installation-responsible-dialog.vue?vue&type=template&id=8aaf0dae&scoped=true", function () {
      api.rerender('8aaf0dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/installation/components/edit-installation-responsible-dialog.vue"
export default component.exports